export default {
  INVALID_VALUE: 'EC_V_001',
  VALUE_OUT_OF_RANGE: 'EC_V_002',
  TG_HDL_ERROR: 'EC_U_001',
};
